import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-duplicate-calculation',
  templateUrl: './duplicate-calculation.component.html',
  styleUrls: ['./duplicate-calculation.component.scss'],
  standalone: false,
})
export class DuplicateCalculationComponent implements OnInit {

  constructor(public activeModal: NgbActiveModal) {
  }

  ngOnInit(): void {
  }

}
